// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.ql-toolbar {
    top: 8px;
    position: sticky;
    z-index: 1000;
    backdrop-filter: blur(5px);
    background: rgba(255, 255, 255, 0.8)!important;
    border: 1px solid #f0f0f0!important;
}`, "",{"version":3,"sources":["webpack://./src/components/recipient-view/fluent-editor-block/fluent-editor-block.css"],"names":[],"mappings":";AACA;IACI,QAAQ;IACR,gBAAgB;IAChB,aAAa;IACb,0BAA0B;IAC1B,8CAA8C;IAC9C,mCAAmC;AACvC","sourcesContent":["\n.ql-toolbar {\n    top: 8px;\n    position: sticky;\n    z-index: 1000;\n    backdrop-filter: blur(5px);\n    background: rgba(255, 255, 255, 0.8)!important;\n    border: 1px solid #f0f0f0!important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
